import { AxiosInstance, AxiosInstancePatch } from "./axiosInstance";

export class MainService {
    searchProduct = (barCode) => AxiosInstance.get('/product/'+barCode);
    searchRcgProduct = (barCode) => AxiosInstance.get('/rcg/product-rcg/identify/'+barCode);
  addGrid = (Grid) => AxiosInstance.post('/grids', Grid);
    getGrid = (id) => AxiosInstance.get('/grids/'+id);
    filterGrid = (Grid) => AxiosInstance.get('/grids?registrationNumber='+Grid.registrationNumber+'&drmNumber='+Grid.drmNumber);
    getManufacturers= () => AxiosInstance.get('/manufacturers?productItems.status=ready&exists%5BproductItems%5D=true');
    addItemsToGrid = (GridID, items) => AxiosInstance.post('/product_items/add_to_grid/'+GridID, items);
    addItemToGrid = (GridID, item) => AxiosInstance.post('/product_items/add_to_grid/'+GridID, item);
     finishGrid = (GridID) => AxiosInstancePatch.patch('/product_items/terminate_grid/'+GridID, {});

     getItemsByManufacturer= (ManufacturerId) => AxiosInstance.get('/product_items?status=ready&manufacturer='+ManufacturerId);

    sendItems = (ManufacturerId, items) => AxiosInstance.post('/product_items//send_to_manufacturer/'+ManufacturerId, items);

    createProductRcg  = (data) => AxiosInstance.post('/rcg/product-rcg', data);
    patchRcgActions   = (id, data) => AxiosInstancePatch.patch(`/rcg/product-rcg/${id}`, data);

    // [S3] Envoi du filename uuid après upload S3
    importRcg     = (filename) => AxiosInstance.post('/rcg/import', { filename });

    // [PROVISOIRE] Envoi direct du fichier en multipart/form-data
    // Content-Type: undefined retire le header de l'instance pour laisser axios
    // générer automatiquement la boundary multipart correcte.
    importRcgFile = (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return AxiosInstance.post('/rcg/import', formData, {
            headers: { 'Content-Type': undefined },
        });
    };

    exportRcg = (date_debut, date_fin) => AxiosInstance.post('/rcg/export', { date_debut, date_fin }, { responseType: 'blob' });

    getUsers         = ()           => AxiosInstance.get('/users');
    updateUserRoles  = (id, roles)  => AxiosInstancePatch.patch(`/users/${id}`, { roles });
}
